import { getRandomNumber } from '../../utils/dummy-data';
import { LatestCashRegisterSession } from '../model/cash-register-session';
import { CashMovementType } from '../model/enum/cash-movement-type';

const currentDate = new Date();
export const CASH_DRAWER: LatestCashRegisterSession = {
  id: 1,
  hasOngoingSession: false,
  storeName: 'Main Outlet',
  registerName: 'Main Register',
  staffName: 'John Doe',
  numOfClosuresToday: '4',
  openingTime: new Date(),
  closingTime: new Date(),

  user: {
    id: 0
  },

  movements: [
    {
      id: 1,
      amount: getRandomNumber(2000, 5000, 10),
      time: new Date(currentDate.setHours(9)),
      title: '',
      note: 'Opening Cash',
      type: CashMovementType.CASH_IN,
    },
    {
      id: 2,
      amount: 50,
      time: new Date(currentDate.setHours(10)),
      title: '',
      note: 'Coffee',
      type: CashMovementType.CASH_OUT,
    },
    {
      id: 3,
      amount: 20,
      time: new Date(currentDate.setHours(11)),
      title: '',
      note: 'Courier Payment',
      type: CashMovementType.CASH_OUT,
    },
  ],

  // Computed in cash service
  countedCash: 0,
  expectedCash: 0,
  expectedVsCountedCashDifference: 0,
  cashToLeaveInDrawer: 0,
  cashToBank: 0,

  cashPaymentsReceived: getRandomNumber(5000, 20000),
  gCashPaymentsReceived: 200,
  creditPaymentsReceived: 2300,
  totalPaymentsReceived: 0,
  cashPaymentsReversed: 0,
  totalPaymentsReversed: 0,
  grossTotal: 0,
  register: {
    id: 1,
    name: "Main Register",
    store: {
      id: 1,
      name: "Main Outlet"
    }
  }
};
